'use strict';

import {Dialog} from './dialog.js';

export class DialogVipguidewelcome extends Dialog {
	constructor(component_key) {
		super(component_key);
	}

	on_show() {
		jQuery('html').addClass('js-no_scroll');
		setTimeout(() => {
			jQuery(`.js-${this.id}_position`).addClass('js-active');
		}, 50);
	}

	on_close() {
		jQuery(`.js-${this.id}_position`).removeClass('js-active');
		jQuery('html').removeClass('js-no_scroll');
	}

	add_events() {
		super.add_events();
		jQuery(document).off('click.vip_guide_welcome_complete').on('click.vip_guide_welcome_complete', '.js-vip_guide_welcome_complete', () => {
			this.hide();
			const dialog = yalwa.v.component_instances?.['dialog_vipguidewhy'];
			if (dialog) {
				document.dispatchEvent(new CustomEvent('vip_guide_dialog_view', {detail: {view: 'checklist'}}));
				jQuery('.js-dialog_vipguidewhy').appendTo('body');
				dialog.show();
			}
		});
		// skip = seen: persist the dismissal through the profilepage service
		jQuery(document).off('click.vip_guide_welcome_dismiss').on('click.vip_guide_welcome_dismiss', '.js-vip_guide_welcome_skip, .js-dialog_vipguidewelcome .dialog__close_icon', () => {
			const csrf = this.component?.csrf;
			if (csrf) {
				yalwa.basics.ajaxservice({
					type: 'POST',
					resource: 'profilepage',
					action: 'dismiss_vip_guide',
					csrf: csrf
				});
			}
		});
	}
}
